export default "__VITE_ASSET__Leo9Z8lh__"